import { j as d } from "./jsx-runtime-3tyXYecC.mjs";
import { f as i } from "./index-LyFokDcn.mjs";
import { b as k, m as C } from "./tss-DN0acMKN.mjs";
import * as w from "react";
import { g as S, c as x } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as R } from "./memoTheme-BzXKG_-k.mjs";
import { g as $ } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { k as h, c as f } from "./emotion-react.browser.esm-BdEGsKDn.mjs";
import { s as U, u as M, c as A } from "./DefaultPropsProvider-CFfEbxdP.mjs";
function j(t) {
  return String(t).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function F(t) {
  return parseFloat(t);
}
function N(t) {
  return S("MuiSkeleton", t);
}
$("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const X = (t) => {
  const {
    classes: a,
    variant: e,
    animation: o,
    hasChildren: n,
    width: r,
    height: s
  } = t;
  return A({
    root: ["root", e, o, n && "withChildren", n && !r && "fitContent", n && !s && "heightAuto"]
  }, N, a);
}, l = h`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, p = h`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, B = typeof l != "string" ? f`
        animation: ${l} 2s ease-in-out 0.5s infinite;
      ` : null, K = typeof p != "string" ? f`
        &::after {
          animation: ${p} 2s linear 0.5s infinite;
        }
      ` : null, T = U("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (t, a) => {
    const {
      ownerState: e
    } = t;
    return [a.root, a[e.variant], e.animation !== !1 && a[e.animation], e.hasChildren && a.withChildren, e.hasChildren && !e.width && a.fitContent, e.hasChildren && !e.height && a.heightAuto];
  }
})(R(({
  theme: t
}) => {
  const a = j(t.shape.borderRadius) || "px", e = F(t.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: t.vars ? t.vars.palette.Skeleton.bg : k(t.palette.text.primary, t.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${e}${a}/${Math.round(e / 0.6 * 10) / 10}${a}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (t.vars || t).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren && !o.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren && !o.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: B || {
        animation: `${l} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(t.vars || t).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: K || {
        "&::after": {
          animation: `${p} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), W = /* @__PURE__ */ w.forwardRef(function(a, e) {
  const o = M({
    props: a,
    name: "MuiSkeleton"
  }), {
    animation: n = "pulse",
    className: r,
    component: s = "span",
    height: c,
    style: g,
    variant: y = "text",
    width: v,
    ...u
  } = o, m = {
    ...o,
    animation: n,
    component: s,
    variant: y,
    hasChildren: !!u.children
  }, b = X(m);
  return /* @__PURE__ */ d.jsx(T, {
    as: s,
    ref: e,
    className: x(b.root, r),
    ownerState: m,
    ...u,
    style: {
      width: v,
      height: c,
      ...g
    }
  });
}), D = C()(({ borderRadiuses: t, constructs: a, mixins: e }) => ({
  root: {
    borderRadius: i.ifFeature("encore", t[500]),
    backgroundColor: i.ifFeature("encore", e.alpha(a.surface.neutral.xxStrong, 0.2)),
    transform: i.ifFeature("encore", "none")
  }
}));
function H(t) {
  const { animation: a = "wave", className: e, ...o } = t, { classes: n, cx: r } = D();
  return /* @__PURE__ */ d.jsx(W, { animation: a, className: r(n.root, e), ...o, "data-fabric-component": "Skeleton" });
}
export {
  H as S
};
//# sourceMappingURL=skeleton-BjVCYQLp.mjs.map
